var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-btn-cont",style:({ backgroundColor: _vm.selected ? '#e1a732': '#fff'})},[_c('div',{staticClass:"gallery-btn-text"},[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"gallery-btn-icon",style:({
        width: _vm.iconWidth + 'px',
        height: _vm.iconHeight + 'px',
        transform: _vm.rotate ? 'rotate(90deg)' : 'rotate(0)'
      }),attrs:{"src":_vm.icon,"alt":"icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }